import { render, staticRenderFns } from "./PanoramaFrame.vue?vue&type=template&id=d974b9a2&scoped=true"
import script from "./PanoramaFrame.vue?vue&type=script&lang=js"
export * from "./PanoramaFrame.vue?vue&type=script&lang=js"
import style0 from "./PanoramaFrame.vue?vue&type=style&index=0&id=d974b9a2&prod&scoped=true&lang=css"
import style1 from "./PanoramaFrame.vue?vue&type=style&index=1&id=d974b9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d974b9a2",
  null
  
)

export default component.exports